import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'app/service/common.service';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { CustomMessages } from '../custom-messages/custom-messages';
import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { WorkflowRequestSearchDTO } from 'app/model/workflow-request-search-dto';

@Component({
  selector: 'app-templatefilter',
  templateUrl: './templatefilter.component.html',
  styleUrls: ['./templatefilter.component.scss']
})
export class TemplatefilterComponent implements OnInit {

  selected = [];
  auditFirmList: ComboPopulation[];
  copyAuditFirmList: ComboPopulation[];
  items: ComboPopulation[];
  departmentComboList: ComboPopulation[];
  copyDepartmentList: ComboPopulation[];
  companyComboList: ComboPopulation[];
  copyCompanyList: ComboPopulation[];
  siteComboList: ComboPopulation[];
  copySiteList: ComboPopulation[];
  commonDto: CommonDTO = new CommonDTO();
  showDeptAllOption: boolean = true;
  showCompanyAllOption: boolean = true;
  showSiteAllOption: boolean = true;
  showFirmAllOption: boolean = true;
  //All
  isFirmAllChecked: boolean = false;
  isDeptAllChecked: boolean = false;
  isCompanyAllChecked: boolean = false;
  isSiteAllChecked: boolean = false;
  workflowSearchDto: WorkflowRequestSearchDTO = new WorkflowRequestSearchDTO();
  searchFirm: string;
  searchDept: string;
  searchCompany: string;
  searchSite: string;
  @Output() filterValues = new EventEmitter<WorkflowRequestSearchDTO>();

  response = [];
  @Output() closePanel: EventEmitter<boolean> = new EventEmitter();
  constructor(private commonService: CommonService, private sidebarComponent: SidebarComponent, private customMessage: CustomMessages) { }

  ngOnInit() {
    this.getAuditFirmList();
    this.getDepartmentList();
    this.getCompanyList();
    this.getSiteList();
  }
  closed() {
    this.closePanel.emit(false);
  }
  toggle(event) {

  }

  getAuditFirmList() {

    //this.sidebarComponent.showHideLoader(true);
    this.commonService.getAuditFirmList()
      .subscribe((data: any) => {
        //  this.sidebarComponent.showHideLoader(false);
        this.response = data;

        this.auditFirmList = this.response;
        this.copyAuditFirmList = this.response;

      }, (error) => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });

  }
  getDepartmentList() {
    // this.sidebarComponent.showHideLoader(true);
    this.commonService.getDepartmentList()
      .subscribe((data: any) => {

        // this.sidebarComponent.showHideLoader(false);
        this.response = data;

        this.departmentComboList = this.response;
        this.copyDepartmentList = this.response;

      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        this.sidebarComponent.showHideLoader(false);
      });
  }
  getCompanyList() {
    //this.sidebarComponent.showHideLoader(true);
    this.commonService.getCompanyList(this.commonDto)
      .subscribe((data: any) => {

        // this.sidebarComponent.showHideLoader(false);
        this.response = data;

        this.companyComboList = this.response;
        this.copyCompanyList = this.response;

      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        this.sidebarComponent.showHideLoader(false);
      });
  }
  getSiteList() {
    // this.sidebarComponent.showHideLoader(true);
    this.commonService.getSiteComboList(this.commonDto)
      .subscribe((data: any) => {


        this.response = data;

        this.siteComboList = this.response;
        this.copySiteList = this.response;
        // this.sidebarComponent.showHideLoader(false);

      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        this.sidebarComponent.showHideLoader(false);
      });
  }

  toggleSelectAll(listType) {

    if (listType.toLowerCase() === 'firmlist' && this.isFirmAllChecked) {
      this.auditFirmList.map((o: any, index) => {
        o.checked = true;

      })

    } else if (listType.toLowerCase() === 'departmentlist' && this.isDeptAllChecked) {
      this.departmentComboList.map((o: any, index) => {
        o.checked = true;

      })

    }
    else if (listType.toLowerCase() === 'companylist' && this.isCompanyAllChecked) {
      this.companyComboList.map((o: any, index) => {
        o.checked = true;

      })
      this.onCompanyCheckedChange();

    } else if (listType.toLowerCase() === 'sitelist' && this.isSiteAllChecked) {
      this.siteComboList.map((o: any, index) => {
        o.checked = true;

      })

    }
    else if (listType.toLowerCase() === 'firmlist' && !this.isFirmAllChecked) {
      this.auditFirmList.map((o: any, index) => {
        o.checked = false;

      })

    } else if (listType.toLowerCase() === 'departmentlist' && !this.isDeptAllChecked) {
      this.departmentComboList.map((o: any, index) => {
        o.checked = false;

      })

    }
    else if (listType.toLowerCase() === 'companylist' && !this.isCompanyAllChecked) {
      this.companyComboList.map((o: any, index) => {
        o.checked = false;

      })

    }
    else if (listType.toLowerCase() === 'sitelist' && !this.isSiteAllChecked) {
      this.siteComboList.map((o: any, index) => {
        o.checked = false;

      })

    }

  }

  resetFilter() {

    this.auditFirmList.map((o: any, index) => {
      o.checked = false;

    })
    this.departmentComboList.map((o: any, index) => {
      o.checked = false;

    })
    this.companyComboList.map((o: any, index) => {
      o.checked = false;

    })
    this.siteComboList.map((o: any, index) => {
      o.checked = false;

    })
    this.isFirmAllChecked = false;
    this.isDeptAllChecked = false;
    this.isSiteAllChecked = false;
    this.isCompanyAllChecked = false;
    this.workflowSearchDto.searchAuditFirmIds = "";
    this.workflowSearchDto.searchCompanyIds = "";
    this.workflowSearchDto.searchDeptIds = "";
    this.workflowSearchDto.searchSiteIds = "";
    this.filterValues.emit(this.workflowSearchDto);
    this.departmentComboList = this.copyDepartmentList;
    this.auditFirmList = this.copyAuditFirmList;
    this.siteComboList = this.copySiteList;
    this.companyComboList = this.copyCompanyList;
    this.searchFirm = "";
    this.searchDept = "";
    this.searchSite = "";
    this.searchCompany = "";
    this.showDeptAllOption = true;
    this.showFirmAllOption = true;
    this.showCompanyAllOption = true;
    this.showSiteAllOption = true;

    //this.closed();
  }
  applyFilter() {

    let selectedDept;
    let selectedFirm;
    let selectedCompany;
    let selectedSite;

    selectedFirm = this.auditFirmList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    selectedDept = this.departmentComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    selectedCompany = this.companyComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    selectedSite = this.siteComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    this.workflowSearchDto.searchAuditFirmIds = selectedFirm;
    this.workflowSearchDto.searchCompanyIds = selectedCompany;
    this.workflowSearchDto.searchSiteIds = selectedSite;
    this.workflowSearchDto.searchDeptIds = selectedDept;
    this.filterValues.emit(this.workflowSearchDto);

    this.closed();
  }

  filterComboList(text, comboListType) {
    if (comboListType.toLowerCase() == 'departmentlist') {
      this.departmentComboList = this.copyDepartmentList;
      this.items = this.departmentComboList;
      if (text === "") {
        this.departmentComboList = this.copyDepartmentList;
        this.showDeptAllOption = true;
      }
      if (text != '') {
        this.items = this.departmentComboList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
        this.assignCopy(comboListType.toLowerCase());
        this.showDeptAllOption = false;
      }
    }
    else if (comboListType.toLowerCase() == 'companylist') {
      this.companyComboList = this.copyCompanyList;
      this.items = this.companyComboList;
      if (text === "") {
        this.companyComboList = this.copyCompanyList;
        this.showCompanyAllOption = true;
      }
      if (text != '') {
        this.items = this.companyComboList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
        this.assignCopy(comboListType.toLowerCase());
        this.showCompanyAllOption = false;
      }
    }
    else if (comboListType.toLowerCase() == 'sitelist') {
      this.siteComboList = this.copySiteList;
      this.items = this.siteComboList;
      if (text === "") {
        this.siteComboList = this.copySiteList;
        this.showSiteAllOption = true;
      }
      if (text != '') {
        this.items = this.siteComboList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
        this.assignCopy(comboListType.toLowerCase());
        this.showSiteAllOption = false;
      }
    }
    else if (comboListType.toLowerCase() == 'firmlist') {
      this.auditFirmList = this.copyAuditFirmList;
      this.items = this.auditFirmList;
      if (text === "") {
        this.auditFirmList = this.copyAuditFirmList;
        this.showFirmAllOption = true;
      }
      if (text != '') {
        this.items = this.auditFirmList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
        this.assignCopy(comboListType.toLowerCase());
        this.showFirmAllOption = false;
      }
    }
  }
  assignCopy(comboListType) {

    if (comboListType == 'departmentlist') {
      this.departmentComboList = Object.assign([], this.items);
    }
    else if (comboListType == 'firmlist') {
      this.auditFirmList = Object.assign([], this.items);
    }
    else if (comboListType == 'companylist') {
      this.companyComboList = Object.assign([], this.items);
    }
    else if (comboListType == 'sitelist') {
      this.siteComboList = Object.assign([], this.items);
    }

  }

  onCompanyCheckedChange() {
    let selectedCompany;
    selectedCompany = this.companyComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    this.getSiteSelectionListByCompanyIdNUserId(selectedCompany);
  }



  getSiteSelectionListByCompanyIdNUserId(companyId) {
    this.commonDto.companyId = companyId;
    this.commonService.getSiteSelectionListByCompanyIdNUserId(this.commonDto)
      .subscribe((data: any) => {
        this.siteComboList = data;
        this.copySiteList = this.siteComboList;
      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
  }


}